import Vue from 'vue'
Vue.config.productionTip = false;

import Newsletter from './components/Newsletter';
import Gallery from './components/Gallery';
import Faqs from './components/Faqs';

let concertinas = require('./components/Concertinas.jquery.js');


window.debounce = function(func){
    let timer;
    return function (event){
        if (timer) clearTimeout(timer);
        timer = setTimeout(func,500, event);
    };
}


// Fix for Vue removing jQuery event handlers
jQuery.holdReady(true);


document.addEventListener('DOMContentLoaded', function (event) {
    document.getElementsByTagName('body')[0].classList.remove('no-js');

    new Vue({
        el: '#app',
        components: {
            Newsletter,
            Gallery,
            Faqs,
        },
        mounted() {
            // Fix for Vue removing jQuery event handlers
            jQuery.holdReady(false);
        }
    });

    concertinas();


    // External links
    jQuery(document).ready(function($) {
        jQuery('a')
            .filter('[href^="http"], [href^="//"]')
            .not('[href*="' + window.location.host + '"]')
            .attr('rel', 'noopener noreferrer')
            .attr('target', '_blank');
    });
});